import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-ventas-mes',
  templateUrl: './ventas-mes.component.html',
  styleUrls: ['./ventas-mes.component.css']
})
export class VentasMesComponent implements OnInit {

  url:string;
  urlSafe: SafeResourceUrl;
  
    constructor(public sanitizer: DomSanitizer) { }
  
    ngOnInit() {
      this.url=environment.apiReportes+"ventas_mensuales.rptdesign&idEmisor="+localStorage.getItem('id');
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
   
    }

  }